import React, { useRef } from "react";
import { Button } from "../Button";
import { FileSelector } from "../../form/Dropzone";

export const FileSelectButton = ({ children, accept, multiple, onSelect, ...props }) => {
    const fileSelectorRef = useRef();
    return (
        <Button onClick={() => fileSelectorRef.current.open()} {...props}>
            {children}
            <FileSelector ref={fileSelectorRef} onSelect={onSelect} multiple={multiple} accept={accept} />
        </Button>
    );
};
